module.exports = __webpack_public_path__ + "ea2c4258aacd2e3a79066a507ab64b9e.svg";